/**
 * Convert API opening hours format to form format
 */
export function convertOpeningHoursFormat(apiOpeningHours: any): any {
  if (!apiOpeningHours) {
    return {
      monday: { isOpen: false, from: "", to: "" },
      tuesday: { isOpen: false, from: "", to: "" },
      wednesday: { isOpen: false, from: "", to: "" },
      thursday: { isOpen: false, from: "", to: "" },
      friday: { isOpen: false, from: "", to: "" },
      saturday: { isOpen: false, from: "", to: "" },
      sunday: { isOpen: false, from: "", to: "" },
    };
  }

  const convertedHours: any = {};
  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  
  days.forEach(day => {
    if (apiOpeningHours[day]) {
      convertedHours[day] = {
        isOpen: apiOpeningHours[day].active || false,
        from: apiOpeningHours[day].open || "",
        to: apiOpeningHours[day].close || ""
      };
    } else {
      convertedHours[day] = { isOpen: false, from: "", to: "" };
    }
  });

  return convertedHours;
}

/**
 * Detect business features based on type and name
 */
export function detectBusinessFeatures(type: string, name: string): { 
  hasFood: boolean; 
  servesAlcohol: boolean; 
  petFriendly: boolean 
} {
  const lowerType = (type || '').toLowerCase();
  const lowerName = (name || '').toLowerCase();
  
  // Detect if serves food
  const foodTypes = ['restaurant', 'cafe', 'bakery', 'food'];
  const foodKeywords = ['restaurant', 'cafe', 'bistro', 'brasserie', 'kitchen', 'grill', 'pizzeria', 'food'];
  const hasFood = foodTypes.includes(lowerType) || 
                 foodKeywords.some(keyword => lowerName.includes(keyword));
  
  // Detect if serves alcohol
  const alcoholTypes = ['bar', 'restaurant', 'night_club'];
  const alcoholKeywords = ['bar', 'pub', 'brewery', 'wine', 'cocktail', 'nightclub', 'restaurant', 'brasserie'];
  const servesAlcohol = alcoholTypes.includes(lowerType) || 
                       alcoholKeywords.some(keyword => lowerName.includes(keyword));
  
  // Pet friendly detection is more complex, for now default to false
  // This could be enhanced with more specific detection logic
  const petFriendly = false;

  return { hasFood, servesAlcohol, petFriendly };
}

/**
 * Clean up website field from API response
 */
export function cleanWebsiteField(website: any): string | undefined {
  let cleanWebsite: string | undefined = undefined;
  
  if (website) {
    if (typeof website === 'string') {
      cleanWebsite = website;
    } else if (typeof website === 'object' && website !== null) {
      // Handle object format with explicit type assertion
      const websiteObj = website as { value?: string };
      if (websiteObj.value) {
        cleanWebsite = websiteObj.value;
      }
    }
    // Only keep valid URLs, not "undefined" strings
    if (cleanWebsite === 'undefined' || !cleanWebsite) {
      cleanWebsite = undefined;
    }
  }
  
  return cleanWebsite;
}
